import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/selOff.png'
import _imports_1 from '@/assets/imgcaptions/selOn.png'
import _imports_2 from '@/assets/imgcaptions/selOffLow.png'


const _hoisted_1 = { class: "ttsSelRow" }
const _hoisted_2 = { class: "ttsSelRowSwitch" }
const _hoisted_3 = {
  key: 0,
  class: "ttsSelRow"
}
const _hoisted_4 = { class: "ttsSelRowSwitch" }
const _hoisted_5 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 0,
  class: "ttsSelRowTxt"
}
const _hoisted_7 = { class: "ttsSelRow" }
const _hoisted_8 = { class: "ttsSelRowSwitch" }
const _hoisted_9 = {
  src: _imports_2,
  alt: ""
}

import { ref, onMounted,watch,getCurrentInstance } from 'vue'
import {captionTtsStore} from "@/store/captionTts.ts"
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
import ttsOpenApi from "@/api/newCaption/ttsOpen.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'ttsSel',
  emits: ['isOpen','closeThis'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance()
const ttstore=captionTtsStore()
const ttsOpen=ref(false)
const transOnOff=ref(false)
const transTxt=ref(false)
const transOnHeight=ref(false)
const haveTrans=ref(false)// 是否有译文
let emit=__emit
onMounted(()=>{
    console.log('-------------')
    console.log(ttstore.isOpen)
    
    ttsOpen.value=ttstore.isOpen
    transOnHeight.value=ttstore.isHeightLight
    haveTrans.value=ttstore.isHaveTranslation
    transOnOff.value=ttstore.isDubbing
    transTxt.value=false
    if(ttstore.translationStatus==1&&ttstore.isOpen){
        console.log('生成中')
            transTxt.value=true
    }
    
    isOpenttsFun()
    // setTimeout(()=>{
    //     transTxt.value=ttstore.isloadDubbing
    // },100)
    
})
const  isOpenttsFun=()=>{
     ttsOpenApi.getTtsState(ttstore.textId,0).then((res:any)=>{
        console.log('打开tts获取状态')
       
        ttstore.updateTranslationStatus(res.data.translationStatus)
       if(res.data.translationStatus==1&&ttstore.isOpen){
           ttstore.loadState(true)
           transTxt.value=true
       }else if((res.data.translationStatus==100||res.data.translationStatus==1)&&ttstore.isOpen){
            ttstore.loadState(false)
            transTxt.value=false
       }
      
    })
}


const openTTS=()=>{
    ttsOpen.value=ttstore.toOpen()
    isOpenttsFun()
    emit('isOpen',ttsOpen.value)
    // ttsOpen.value=true
    // ttstore.toOpen()
    // console.log(ttstore.isOpen)
}
// 关闭变声
const closeTTS=()=>{
    // ttsOpen.value=false
    transOnOff.value=false
    transTxt.value=false
    ttsOpen.value=ttstore.toClose()
    emit('isOpen',ttsOpen.value)
    // console.log(ttstore.isOpen)
}
// 译文
watch(transOnOff, (newVal) => {
    if(newVal){
        ttstore.dubbingOpen()
        if(ttstore.translationStatus<100){
            transTxt.value=true
        }
    }else{
        ttstore.dubbingClose()
    }
    // if(newVal&&!ttstore.isDubbing){
    //     ttstore.loadState(true)
    //     transTxt.value=true
       
    // }
});
const transOnOffFun=()=>{
    transOnOff.value=true
    ttstore.dubbingOpen()
    // transTxt.value=true
}
// 超出字幕时长高亮
const opentransOnHeight=()=>{
    transOnHeight.value=true
    ttstore.heightLightOpen()
}
const closetransOnHeight=()=>{
    transOnHeight.value=false
    ttstore.heightLightClose()
}   
//  接受推送消息
// onMounted(() => {
//     proxy.$ws.onmessageCaption = (message: any) => {
//         console.log(message)
//         if(ttstore.textId==message.textId ){
//            isOpenttsFun()
//         }
        
//     }
// })
const closePage=()=>{
    emit('closeThis')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ttsSelBox",
    onMouseleave: closePage
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ttsSelRowTitle" }, "幻音", -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("img", {
          src: _imports_0,
          alt: "",
          onClick: _withModifiers(openTTS, ["stop"])
        }, null, 512), [
          [_vShow, !ttsOpen.value]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_1,
          alt: "",
          onClick: _withModifiers(closeTTS, ["stop"])
        }, null, 512), [
          [_vShow, ttsOpen.value]
        ])
      ])
    ]),
    (haveTrans.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(ttsOpen.value?'ttsSelRowTitle':'ttsSelRowTitleLow')
          }, "译文配音", 2),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
              [_vShow, !ttsOpen.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _withModifiers(transOnOffFun, ["stop"])
            }, null, 512), [
              [_vShow, ttsOpen.value&&!transOnOff.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (transOnOff.value=false), ["stop"]))
            }, null, 512), [
              [_vShow, ttsOpen.value&&transOnOff.value]
            ])
          ], 512), [
            [_vShow, !transTxt.value]
          ]),
          (transTxt.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 译文配音生成中… "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(ttsOpen.value?'ttsSelRowTitle':'ttsSelRowTitleLow')
      }, "超出字幕时长高亮", 2),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
          [_vShow, !ttsOpen.value]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_0,
          alt: "",
          onClick: _withModifiers(opentransOnHeight, ["stop"])
        }, null, 512), [
          [_vShow, ttsOpen.value&&!transOnHeight.value]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: _imports_1,
          alt: "",
          onClick: _withModifiers(closetransOnHeight, ["stop"])
        }, null, 512), [
          [_vShow, ttsOpen.value&&transOnHeight.value]
        ])
      ])
    ])
  ], 32))
}
}

})